import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface COMCInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function COMCInternalControls({ onBack, setActiveSection, controlsListSection }: COMCInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Cost of Materials Consumed"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}


